(function(angular){
	'use strict';

	angular
		.module('authModule')
		.controller('additionalResetQuestionsIraController', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			AdditionalResetQuestionsIraController
		]);

	function AdditionalResetQuestionsIraController(
		$timeout,
		globalConfig,
		urlFactory
	){
		var additionalResetQuestionsIra = this;

		additionalResetQuestionsIra.$onInit = function() {
			angular.extend(additionalResetQuestionsIra, globalConfig);
			
			if(angular.isDefined(additionalResetQuestionsIra.serverSideErrorMap)) {
				$timeout(function() {
					urlFactory.handleServerValidation(
						additionalResetQuestionsIra.additionalResetQuestionsIraForm,
						urlFactory.spoofApiError(additionalResetQuestionsIra.serverSideErrorMap)
					);
				}, 100);
			}
		};
	}
})(window.angular);